import axios from 'axios';
import errorMessage from './errorMessage';
import {
  UPDATE_TRIBUN_NICKNAME_REQUEST,
  UPDATE_TRIBUN_NICKNAME_SUCCESS,
  UPDATE_TRIBUN_NICKNAME_FAILURE,

  UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST,
  UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS,
  UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE,

  UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST,
  UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS,
  UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE,

  POST_TRIBUN_AVATAR_REQUEST,
  POST_TRIBUN_AVATAR_SUCCESS,
  POST_TRIBUN_AVATAR_FAILURE,

  DELETE_TRIBUN_AVATAR_REQUEST,
  DELETE_TRIBUN_AVATAR_SUCCESS,
  DELETE_TRIBUN_AVATAR_FAILURE,

  SWITCH_TRIBUN_TAB
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

import { openModal } from 'Store/actions';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const updateTribunNickname = newNickname => async dispatch => {
  const body = {
    channel: '0',
    nickname: newNickname
  };

  try {
    dispatch({
      type: UPDATE_TRIBUN_NICKNAME_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/v2/user/nickname`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: UPDATE_TRIBUN_NICKNAME_SUCCESS,
      payload: res.data.nickname
    });

    return res.data;

  } catch (e) {
    dispatch({
      type: UPDATE_TRIBUN_NICKNAME_FAILURE,
      payload: e.response?.data
    });

    return e.response?.data;
  }
};

export const updateTribunCommitPermission = newSettings => async (dispatch, getState) => {

  const body = {
    channel: '0',
    preferences: {
      profile: {
        allowComment: newSettings
      }
    }
  };

  try {
    dispatch({
      type: UPDATE_TRIBUN_COMMIT_PERMISSION_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/preferences`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: UPDATE_TRIBUN_COMMIT_PERMISSION_SUCCESS,
      payload: res.data.tribunPreferences.preferences.profile.allowComment
    });

  } catch (e) {

    dispatch({
      type: UPDATE_TRIBUN_COMMIT_PERMISSION_FAILURE,
      payload: errorMessage
    });
  }
};

export const updateTribunAutoSpaceCouponShare = newSettings => async (dispatch, getState) => {

  const body = {
    channel: '0',
    preferences: {
      profile: {
        autoSpaceCouponShare: newSettings
      }
    }
  };

  try {
    dispatch({
      type: UPDATE_AUTO_SPACE_COUPON_SHARE_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/preferences`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: UPDATE_AUTO_SPACE_COUPON_SHARE_SUCCESS,
      payload: res.data.tribunPreferences.preferences.profile.autoSpaceCouponShare
    });

  } catch (e) {
    console.log('error', e);

    dispatch({
      type: UPDATE_AUTO_SPACE_COUPON_SHARE_FAILURE,
      payload: errorMessage
    });
  }
};

export const switchTribunTab = tabName => dispatch => {
  dispatch({
    type: SWITCH_TRIBUN_TAB,
    payload: tabName
  });
};

export const postTribunAvatar = file => async (dispatch, getState) => {
  try {
    dispatch({
      type: POST_TRIBUN_AVATAR_REQUEST
    });

    const res = await axios({
      method: 'POST',
      url: `${API_GATEWAY}/v2/mobile/tribun/photo`,
      headers: {
        channel: '0',
        'content-type': 'multipart/form-data'
      },
      data: file
    });

    dispatch({
      type: POST_TRIBUN_AVATAR_SUCCESS,
      payload: res.data
    });

    //dispatch(getTribunUser());
    dispatch(openModal('uploadAvatarSuccess'));
  } catch (e) {
    dispatch({
      type: POST_TRIBUN_AVATAR_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    (e.response.data.code === 4017 ||  e.response.data.code === 4018 || e.response.data.code === 4019  || e.response.data.code === 4020)
    && dispatch(openModal('uploadAvatarFailure', { code: e.response.data.code, domain: e.response.data.domain }));
  }
};

export const deleteTribunAvatar = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_TRIBUN_AVATAR_REQUEST
    });

    const res = await axios({
      method: 'DELETE',
      url: `${API_GATEWAY}/v2/mobile/tribun/photo`,
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: DELETE_TRIBUN_AVATAR_SUCCESS,
      payload: res.data.result.url
    });

    dispatch(openModal('removeAvatarSuccess'));
  } catch (e) {
    dispatch({
      type: DELETE_TRIBUN_AVATAR_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    e.response.data.code === 4021 && dispatch(openModal('removeAvatarFailure', { code: e.response.data.code, domain: e.response.data.domain }));
  }
};
